module.exports = __webpack_public_path__ + "media/images/kids-sports-6af08ffef93d2dc6493a047639fade2d.jpg";